import { contactUsConstants } from '../constants/actionTypes'
import * as contactService from '../services/contactUsService'

export const OnChangeOfContactMode = (modeOfContact) => {
  switch (modeOfContact) {
    case 'Phone':
      return {
        type: contactUsConstants.UPDATE_MODE_OF_CONTACT_TO_PHONE,
      }
    case 'Email':
      return {
        type: contactUsConstants.UPDATE_MODE_OF_CONTACT_TO_EMAIL,
      }
  }
}

export const OnContactConsultantSubmission = (didSubmit) => {
  switch (didSubmit) {
    case true:
      return {
        type: contactUsConstants.SUCCESS_CONTACT_CONSULTANT_SUBMISSION,
      }
    case false:
      return {
        type: contactUsConstants.FAILURE_CONTACT_CONSULTANT_SUBMISSION,
      }
  }
}

export const ResetStatusContactConsultant = () => {
  return {
    type: contactUsConstants.RESET_STATUS_CONTACT_CONSULTANT,
  }
}

export const WaitOnContactConsultantSubmission = () => {
  return {
    type: contactUsConstants.INPROGRESS_CONTACT_CONSULTANT_SUBMISSION,
  }
}

export function submitContactConsultantDetails(opportunityId, queryDetails) {
  return (dispatch) => {
    return contactService.submitContactConsultantDetails(
      opportunityId,
      queryDetails,
      dispatch
    )
  }
}
